<template>
    <div style="display: flex; flex-direction: column; padding:15px;">
        <div style="width: 100%; text-align: center; font-size:22pt">SwiftUI Tutorials</div>
        <router-link style="width: 100%; text-align: center; font-size:12pt; cursor: pointer" v-if="singleMode" to="/tutorials">View All Tutorials</router-link>
        <div class="container">
            <div v-for="tutorial in allTutorials" class="tutorialArticle">
                <div class="title">
                    <div style="font-size: 18pt">{{ tutorial.title[tutorial.selectedLocale] }}</div>
                    <div style="margin-left: auto; display:flex;">
                        <div v-if="clipboardAvailable" style="cursor: pointer" @click="copy(tutorial.id)">Share</div>
                        <div v-if="Object.keys(tutorial.articles).length > 1" style="margin-left:15px">
                            <select v-model="tutorial.selectedLocale">
                                <option v-for="lang in Object.keys(tutorial.articles)" :value="lang">{{ languages[lang] }}</option>
                            </select>
                        </div>
                    </div>
                    </div>
                <div class="article" v-html="tutorial.articles[tutorial.selectedLocale]"></div>
            </div>
        </div>
    </div>

</template>


<style>
    .title{
        display:flex;
        align-items: center;
        margin-bottom: 12px;
    }

    .tutorialArticle{
        margin-bottom:45px;
    }

    @media(prefers-color-scheme: dark){
        code{
            color:#DDDDDD !important;
        }
    }

</style>


<script>

    import {db} from "../../main";

    export default {
        name: "Tutorials",
        data: function(){
            return {
                allTutorials: [],
                loading: true,
                singleMode: false,

                languages:{
                    "en-us":"English",
                    "ko-kr":"한국어"
                },
                clipboardAvailable: false
            }
        },
        components: {},

        computed: {
            articles: function(){
                if(this.searchKeyword === "" && this.searchTags.length === 0){
                    return this.allArticles;
                }

                var returnArr = this.allArticles;
                var self = this;

                if (this.searchKeyword !== ""){
                    returnArr = returnArr.filter(function(article){
                        return article.title.toLowerCase().includes(self.searchKeyword.toLowerCase());
                    });
                }

                if (this.searchTags.length !== 0){
                    returnArr = returnArr.filter(function(article){
                        if(self.searchTagUnion){
                            return self.searchTags.every(element => article.tags.includes(element));
                        }else{
                            return article.tags.some(element => self.searchTags.includes(element));
                        }
                    });
                }

                return returnArr;
            },

            allTags: function(){
                let tags = [];
                for(let i = 0; i < this.allArticles.length; i++){
                    // for each article
                    tags.push(...this.allArticles[i].tags.filter(tag => !tags.includes(tag)));
                }

                tags = tags.filter(tag => !this.searchTags.includes(tag));
                return tags.sort((a, b) => a.localeCompare(b));
            }
        },

        methods:{
            copy: function(id){
                let text = "https://mjkwak.me/tutorials?article=" + id;
                navigator.clipboard.writeText(text).then(function() {
                    alert("URL copied to clipboard!");
                }, function(err) {
                    alert(`Failed to copy the URL.\nHere's your link: ${text}`);
                });
            }

        },

        created() {
            if(navigator.clipboard){
                this.clipboardAvailable = true;
            }

            // fetch articles
            const self = this;

            if(typeof this.$route.query.article === "string"){
                this.singleMode = true;
                db.collection("tutorials").doc(this.$route.query.article).onSnapshot(function (querySnapshot) {
                    if(querySnapshot.exists){
                        let data = {
                            id: self.$route.query.article,
                            selectedLocale: window.navigator.language.toLowerCase(),
                            ...querySnapshot.data()
                        };
                        if (!Object.keys(data.articles).includes(data.selectedLocale)) {
                            if (data.articles.keys().includes("en-us")) {
                                data.selectedLocale = "en-us";
                            } else {
                                data.selectedLocale = data.articles.keys()[0];
                            }
                        }
                        self.allTutorials = [data];
                    }else{
                        // no article
                        alert("No");
                    }

                });
            } else {
                db.collection("tutorials").orderBy("date", "desc").onSnapshot(function (querySnapshot) {
                    self.allTutorials = [];
                    querySnapshot.forEach(function (doc) {
                        const data = {
                            id: doc.id,
                            selectedLocale: window.navigator.language.toLowerCase(),
                            ...doc.data(),
                        };
                        console.log(data);

                        if (!Object.keys(data.articles).includes(data.selectedLocale)) {
                            if (Object.keys(data.articles).includes("en-us")) {
                                data.selectedLocale = "en-us";
                            } else {
                                data.selectedLocale = Object.keys(data.articles)[0];
                            }
                        }

                        self.allTutorials.push(data);
                    });

                    self.loading = false;
                });
            }
        }
    }
</script>